import { AfterContentInit, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { AuthenticationService } from '../../../../services/authentication.service';
import { ConfigService } from '../../../../services/config.service';
import { NewViewService } from '../../../../services/new-view.service';
import { NotificationService } from '../../../../services/notification.service';
import { WebSocketService } from '../../../../services/web-socket.service';
import { LaneState } from '../../classes/lane.class';
import { State } from '../../classes/state.class';
import { EditVisitDialogComponent } from '../../dialogs/edit-visit/edit.component';
import { OpenBarDialogComponent } from '../../dialogs/openBar-dialog/openBar.dialog.component';
import { LaneStateService } from '../../../../services/lane-state.service';
import { Subscription } from 'rxjs';
import { PrinterDialogComponent, PrinterDialogData } from '../../dialogs/printer-dialog/printer.dialog.component';
import { Events } from '../../../../knowledge/knowledge';
import { AppConfigService } from '../../../../services/app-config.service';
import { CoreConfig } from '../../../../utils/config';
import { AuthDataService } from '../../../../services/auth.data.service';

// tslint:disable-next-line:class-name
interface movement {
  time: string;
  plate: string;
}
// tslint:disable-next-line:class-name
interface k_data {
  lane: number;
  stateClass: string;
  message1: string;
  message2: string;
}
// tslint:disable-next-line:class-name
interface weight_data {
  lane: number;
  weight: number;
}

@Component({
  selector: 'app-lanecontrol-viewer',
  templateUrl: './lanecontrol-viewer.component.html',
  styleUrls: ['./lanecontrol-viewer.component.scss'],
})
export class LaneControlViewerComponent implements OnInit, AfterContentInit, OnDestroy {
  public laneState: LaneState;
  private authDataSubscription: Subscription;
  private laneSubscription: Subscription;
  private newViewSubscription: Subscription;
  private weightSubscription: Subscription;
  private openBarReassonSubscription: Subscription;
  private syncConfigSubscription: Subscription;
  public stateClass: string;
  public overloadClass: string;
  public kioskState: string;
  public kioskMsg1: string;
  public kioskMsg2: string;
  public weight: number;
  public platePath: string;
  public sinopticImagePath: string;
  public QR: string;
  public liveviewSwitch: boolean;
  public lastMovements: movement[] = [];
  public currentPlate: string;
  public QRForm: FormControl;
  public frontPlateForm: FormControl;
  public laneEnabled: FormControl;
  public autoDetecDirectionMode: FormControl;
  public objectKeys = Object.keys;
  public currentIdMovImage: string;
  public inIdMovImage: string;
  public ocr_frontResultPacket: any;
  public movementFrontImageSrc: any;
  public movementFacialImageSrc: any;
  public movementFacial2ImageSrc: any;
  public movementContextImageSrc: any;
  public showCreateVisit: boolean;
  public authDataAlerts: string[];

  public appConfig: any;

  @Input() laneId: any;
  @Input() laneDirection: any;
  @Input() laneConfig: any;
  @Output() stateChange: EventEmitter<any> = new EventEmitter<any>();
  /**
   * Update error event
   */
  @Output('updatePrinterErrorFromPrinter') updatePrinterErrorEvent: EventEmitter<any> = new EventEmitter();
  @Output() updateLaneConfigEvent: EventEmitter<any> = new EventEmitter();

  constructor(
    @Inject(CoreConfig.API_BASE_URL) private apiBaseUrl,
    public appConfigService: AppConfigService,
    public wsService: WebSocketService,
    private config: ConfigService,
    private laneDataService: LaneStateService,
    private authService: AuthenticationService,
    private dialog: MatDialog,
    private newviewService: NewViewService,
    private authDataService: AuthDataService,
    private notificationService: NotificationService,
    private authenticationService: AuthenticationService
  ) {
    this.appConfig = appConfigService.getConfig();
    this.initVars();
  }

  ngOnInit() {
    this.laneStateSubscriber();
    this.newViewSubscriber();
    this.weightSubscriber();
    this.syncConfigSubscriber();
    this.authDataSubscriber();
  }

  ngAfterContentInit() {
    this.initLaneFunctions();

    setTimeout(() => {
      this.laneDataService.getCurrentLaneData(this.laneId);
      this.authDataService.getCurrentAuthData(this.laneId);
      this.newviewService.getCurrentNewView(this.laneId);
    }, 500);
  }

  ngOnDestroy() {
    this.laneSubscription.unsubscribe();
    this.newViewSubscription.unsubscribe();
    this.weightSubscription.unsubscribe();
    this.syncConfigSubscription.unsubscribe();
    this.authDataSubscription.unsubscribe();
  }

  private initVars() {
    this.kioskState = 'ESPERANDO';
    this.weight = 0;
    this.laneState = null;
    this.currentPlate = null;
    this.movementFacial2ImageSrc = `${this.apiBaseUrl}movements/image/1/1/_F`;
    this.movementFrontImageSrc = `${this.apiBaseUrl}movements/image/1/1/_F`;
    this.movementContextImageSrc = `${this.apiBaseUrl}movements/image/1/1/_F`;
    this.QRForm = new FormControl('', [Validators.maxLength(20), Validators.minLength(20), Validators.pattern('[0-9]{20}')]);
    this.frontPlateForm = new FormControl('');
    this.showCreateVisit = false;
    this.authDataAlerts = [];
  }
  private initLaneFunctions() {
    this.laneEnabled = new FormControl();
    this.autoDetecDirectionMode = new FormControl();
    this.laneEnabled.setValue(this.laneConfig.general.laneEnabled);
    this.autoDetecDirectionMode.setValue(this.laneConfig.general.autoDetecDirectionMode);
  }

  private syncConfigSubscriber() {
    this.syncConfigSubscription = this.wsService.listen('syncConfig').subscribe(
      () => {
        this.config.getConfig().subscribe((data) => {
          data.lanes.forEach((lane: any) => {
            if (lane.id === this.laneId) this.laneConfig = lane;
          });
          this.initLaneFunctions();
        });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  private laneStateSubscriber() {
    this.laneSubscription = this.laneDataService.getStateLane(this.laneId).subscribe((laneState: LaneState) => {
      this.laneState = laneState;
      console.log('L-' + this.laneId + ' lane state actualizado currentState: ' + JSON.stringify(this.laneState));
      if (this.laneState == null) {
        this.getSinopticImagePath(null);
        return;
      }
      if (this.laneState.state != null) {
       
        this.getSinopticImagePath(this.laneState.state);
       
        if (laneState.stateMach.currentState === 'IDDLE') {
          this.resetVarsCarril();
        }
       
        if (
          laneState.authResponsePacket.tag === 'prevNotFoundByQR' ||
          laneState.authResponsePacket.tag === 'prevNotFoundByPlate' ||
          laneState.authResponsePacket.tag === 'denied' ||
          laneState.authResponsePacket.tag === 'error'
        ) {
          //TODO: && Check if module visits is loaded
          this.showCreateVisit = true;
        }
      }
      this.setQRValue();
      this.setFrontPlateValue();
      this.getOCRResultPacket(this.laneState?.OCRPacket, this.laneState?.presenceTimeStamp);
    });
  }

  private newViewSubscriber() {
    this.newViewSubscription = this.newviewService.getKioskState(this.laneId).subscribe(
      (data: k_data) => {
        if (data == null) {
          return;
        }
        const kioskData: k_data = data;
        if (kioskData.lane === Number(this.laneId)) {
          this.stateClass = data.stateClass;
          this.kioskMsg1 = data.message1;
          this.kioskMsg2 = data.message2;
          this.getKioskState(this.stateClass);
          this.updateKioskState();
        }
      },
      // TODO: snackBar
      (err) => {
        console.log(err);
      }
    );
  }

  private authDataSubscriber(){
    this.authDataSubscription = this.authDataService.getAuthData(this.laneId).subscribe(
      (data: any) => {
        if (data == null) {
          return;
        }
        console.log(`Auth data received: ${data}`);
        this.authDataAlerts = data;
      },
      // TODO: snackBar
      (err) => {
        console.log(err);
      }
    );
  }

  private weightSubscriber() {
    this.weightSubscription = this.wsService.listen('weight').subscribe((data: weight_data) => {
      const weightData: weight_data = data;
      if (weightData.lane === Number(this.laneId)) {
        this.weight = Number(weightData.weight);
        this.setOverloadClass(this.weight);
      }
    });
  }

  private resetVarsCarril() {
    console.log('L-' + this.laneId + ' Reset vars carril');
    this.laneState.id_mov = null;
    this.QRForm.setValue(null);
    this.frontPlateForm.setValue(null);
    this.laneState.authResponsePacket.prevision = null;
    this.movementFrontImageSrc = `${this.apiBaseUrl}movements/image/1/1/_F`;
    this.movementFacialImageSrc = `${this.apiBaseUrl}movements/image/1/1/_1`;
    this.movementFacial2ImageSrc = `${this.apiBaseUrl}movements/image/1/1/_2`;
    this.movementContextImageSrc = `${this.apiBaseUrl}movements/image/1/1/_1`;
  }

  private getOCRResultPacket = (packet: any, timeStamp: string) => {
    if (packet == null || packet == {} || timeStamp == null || timeStamp == '') {
      return;
    }else{
      this.ocr_frontResultPacket = packet;
      const spaceId = timeStamp.indexOf(' ', 9);
      let presenceDate = '';
      presenceDate = timeStamp.substring(0, spaceId);
      presenceDate = presenceDate.replace('-', '');
      presenceDate = presenceDate.replace('-', '');
      this.ocr_frontResultPacket.presenceTimeStamp = presenceDate;
    }
  }

  getKioskState = (status: string) => {
    this.kioskState = '';
    switch (status) {
      case 'show_qr_in':
        this.kioskState = 'ESPERANDO QR';
        break;
      case 'show_qr_out':
        this.kioskState = 'ESPERANDO QR';
        break;
      case 'validating':
        this.kioskState = 'VALIDANDO QR';
        break;
      case 'weighing':
        this.kioskState = 'PESANDO';
        break;
      case 'message_ok':
        this.kioskState = 'ACCESO PERMITIDO';
        break;
      case 'print_ticket':
        this.kioskState = 'IMPRIMIENDO';
        break;
      case 'message_denied':
        this.kioskState = 'ACCESO DENEGADO';
        break;
      case 'message_alert':
        this.kioskState = 'ALERTA';
        break;
      case 'underload':
        this.kioskState = `ALERTA CARGA INFERIOR A ${this.laneConfig?.general?.bottomWeightUnderload ?? 'PESO MÍNIMO'}`;
        break;
      case 'waiting':
        this.kioskState = 'ESPERANDO';
        break;
      case 'platesDoNotMatchState':
        this.kioskState = 'MATRICULA NO COINCIDE';
        break;
    }
    return this.kioskState;
  };

  // tslint:disable-next-line:max-line-length
  // updateKioskState envía al padre stateClass de cada laneId para que la label de la tab pueda actulaizar el color en función de stateClass
  private updateKioskState() {
    this.stateChange.emit({ class: this.stateClass, lane: this.laneId });
    console.log(`updateKioskState emitter: ${this.stateClass}`);
  }

  // setea clase text-error si el peso supero los 41000kg
  setOverloadClass(weight: number) {
    const maxWeight = this.laneConfig.general.topWeightOverload ?? undefined;
    if (maxWeight !== undefined) {
      if (weight >= maxWeight) {
        this.overloadClass = 'text-error';
      } else {
        this.overloadClass = '';
      }
    }
  }
  setPlatesNotMatchClass() {
    if (this.laneState == null || this.laneState.authResponsePacket == null) {
      return;
    }
    if (this.laneState.authResponsePacket?.tag != null && this.laneState.authResponsePacket?.tag === 'platesDoNotMatch') {
      return 'blink-alert';
    }
  }
  // getSinopticImagePath devuelve la imagen del sinóptico
  // tslint:disable-next-line:no-shadowed-variable
  getSinopticImagePath = (state: State) => {
    const sinopticImgFolder = this.getSinopticImgFolder();
    this.sinopticImagePath = this.appConfig.installationNameFolder + 'access-manager/assets/' + sinopticImgFolder;
    if (this.laneConfig?.general?.laneType === 'kiosk') {
      this.sinopticImagePath = this.sinopticImagePath.concat('Logo.png');
      return;
    }
    if (Number(this.weight) > 80) {
      this.sinopticImagePath = this.sinopticImagePath.concat('L1_');
    }
    if (state != null) {
      if (state.presence != null && state.presence.state != null && state.presence.state === true) {
        this.sinopticImagePath = this.sinopticImagePath.concat('L1_');
      }
      if (state.security != null && state.security?.state != null && state.security.state === true) {
        this.sinopticImagePath = this.sinopticImagePath.concat('L2_');
      }
      if (state.photocell != null && state.photocell?.state != null && state.photocell.state === true) {
        this.sinopticImagePath = this.sinopticImagePath.concat('FC_');
      }
      if (state.blocked != null && state.blocked?.state != null && state.blocked.state === true) {
        this.sinopticImagePath = this.sinopticImagePath.concat('B_');
      }
      // tslint:disable-next-line:max-line-length
      if (
        (state.closed != null && state.closed?.state != null && state.closed.state === true) ||
        (state.closed == null && state.trafficLight != null && state.trafficLight === 'redTrafficLight')
      ) {
        this.sinopticImagePath = this.sinopticImagePath.concat('C.png');
        // tslint:disable-next-line:max-line-length
      } else if (
        (state.closed != null && state.closed?.state != null && state.closed.state === false) ||
        (state.trafficLight != null && state.trafficLight === 'greenTrafficLight')
      ) {
        this.sinopticImagePath = this.sinopticImagePath.concat('O.png');
      }
    } else {
      this.sinopticImagePath = this.sinopticImagePath.concat('C.png');
    }
    console.log('Sinptic img path: ' + this.sinopticImagePath);
  };
  // getSinopticImageFolder devuelve la carpeta en donde las imagenes están guardades dependiendo si existe báscula, barrera...
  getSinopticImgFolder() {
    let path = 'lane-images/';
    if (this.laneConfig == null) {
      return;
    }
    if (this.laneConfig.general.laneType === 'kiosk') {
      return 'images/';
    }
    if (this.laneConfig.identification?.weigher != null) {
      path = path.concat('bascula');
    }
    if (this.laneConfig.identification?.plates != null) {
      path = path.concat('Camara');
    } else {
      path = path.concat('NoCamara');
    }
    if (this.laneConfig.gate?.sensors?.security != null) {
      path = path.concat('Barrera');
    } else {
      path = path.concat('NoBarrera');
    }
    return `${path}/`;
  }

  validateQR() {
    this.QR = this.QRForm.value;
    if (this.QR.length >= 12 && this.QR.length <= 20) {
      const payload = {
        msg_type: 'QR',
        lane: this.laneId,
        data: {
          QR: this.QR,
          printFlag: false,
        },
      };
      this.wsService.send('newQR', payload);
      // console.log(payload);
      console.log(`QR enviado a validar: ${this.QR}`);
      // this.snackBar.showSuccess(`QR enviado a validar: ${this.QR}`);
      this.QR = null;
    } else {
      console.log('El QR no contiene 20 dígitos');
      // this.snackBar.showErrorTimer('El QR no contiene 20 dígitos');
    }
  }
  printQR() {
    this.QR = this.QRForm.value;
    if (this.QR.length === 20) {
      const payload = {
        msg_type: 'QR',
        lane: this.laneId,
        data: {
          QR: this.QR,
          printFlag: true,
        },
      };
      this.wsService.send('newQR', payload);
      console.log(payload);
      // this.snackBar.showSuccess(`QR enviado a imprimir: ${this.QR}`);
      this.QR = null;
    } else {
      console.log(this.QR.length);
      // this.snackBar.showErrorTimer('El QR no contiene 20 dígitos');
    }
  }
  printLaneLastTicket() {
    this.QR = this.QRForm.value;
    if (this.QR.length === 20) {
      const payload = {
        msg_type: 'printLaneLastTicket',
        lane: this.laneId,
      };
      this.wsService.send('printLaneLastTicket', payload);
      console.log(payload);
      // this.snackBar.showSuccess(`Ticket enviado a imprimir: ${this.QR}`);
      this.QR = null;
    } else {
      // this.snackBar.showErrorTimer('No se ha podido enviar a imprimir el ticket');
    }
  }

  printLaneLastCMR() {
    this.QR = this.QRForm.value;
    if (this.QR.length === 20) {
      const payload = {
        msg_type: 'printLaneLastCMR',
        lane: this.laneId,
      };
      this.wsService.send('printLaneLastCMR', payload);
      console.log(payload);
      // this.snackBar.showSuccess(`Ticket enviado a imprimir: ${this.QR}`);
      this.QR = null;
    } else {
      // this.snackBar.showErrorTimer('No se ha podido enviar a imprimir el ticket');
    }
  }

  // createVisit() crea una visita al vuelo
  createVisit(): void {
    const dialogRef = this.dialog.open(EditVisitDialogComponent, {
      width: '450px',
      disableClose: true,
      data: this.frontPlateForm.value,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.validatePlate(true);
      }
    });
  }
  validatePlate(retryAuth?: any) {
    const plate = this.frontPlateForm.value;
    if (plate !== '') {
      const payload = {
        msg_type: 'newPlate',
        lane: this.laneId,
        data: {
          plate,
          retryAuth: retryAuth ? true : false,
        },
      };
      this.wsService.send('newPlate', payload);
      console.log('New plate sent: ' + plate);
    }
  }
  // openBar(id) abre un diálogo que permite enviar el motivo por el que se ha abierto la barrera.
  openBar(id: number) {
    console.log('abrir la barrera', id);
    const payload = {
      msg_type: 'open',
      lane: id,
      openingUser: this.authService.currentUser.name,
      openingMsg: '',
    };
    const dialogRef = this.dialog.open(OpenBarDialogComponent, {
      width: '400px',
      disableClose: true,
      data: payload,
    });
    this.openBarReassonSubscription = dialogRef.afterClosed().subscribe(
      (value) => {
        if (value) {
          console.log(value);
          this.wsService.send('bar', value);
          this.notificationService.showSuccess(`Abrir barrera ${value.lane}. Orden enviada.`);
          this.openBarReassonSubscription.unsubscribe();
        }
      },
      (err) => {
        this.openBarReassonSubscription.unsubscribe();
        this.notificationService.showError(err);
      }
    );
  }
  closeBar(id): void {
    console.log('cerrar la barrera', id);
    const payload = {
      msg_type: 'close',
      lane: id,
    };
    this.wsService.send('bar', payload);
  }
  getTimeStampSecond = (): string => {
    const now: Date = new Date();
    const seconds: string = ('0' + now.getSeconds().toString()).slice(-2);
    return seconds;
  };
  private setQRValue() {
    if (this.stateClass === 'waiting') {
      // resetea QR
      this.QRForm.setValue(null);
    } else {
      // actualiza QR
      if (this.laneState.authRequestedPacket?.QR === '' || this.laneState.authRequestedPacket?.QR == null) {
        return;
      } else {
        this.QRForm.setValue(this.laneState.authRequestedPacket.QR);
      }
    }
  }
  private setFrontPlateValue() {
    if (this.stateClass === 'waiting') {
      this.frontPlateForm.setValue(null);
    } else {
      if (this.laneState.OCRFrontResultPacket?.plate === '' || this.laneState.OCRFrontResultPacket?.plate == null) {
        return;
      } else {
        this.frontPlateForm.setValue(this.laneState.OCRFrontResultPacket.plate);
        console.log('UPDATE PLATE IMAGE');
        this.movementFrontImageSrc = `${this.apiBaseUrl}movements/image/${this.getFormatDate(new Date())}/${this.getFormatMovImg(this.laneState.id_mov)}/_F`;
      }
    }
  }

  getFormatDate = (fecha): string => {
    let fechaModificada = new Date(fecha);
    fechaModificada = new Date(fechaModificada.getTime() - fechaModificada.getTimezoneOffset());
    // console.log(fechaModificada);
    const year = fechaModificada.getFullYear();
    const month = ('0' + (fechaModificada.getMonth() + 1).toString()).slice(-2);
    const day = ('0' + fechaModificada.getDate().toString()).slice(-2);
    return year + month + day;
  };
  getFormatMovImg = (moviment): string => {
    if (!moviment) {
      return;
    }
    // let imagen = '0000000000' + moviment.toString();
    // imagen = imagen.toString().slice(-8);
    // imagen += '_1.jpg';
    const imagen = moviment.toString();
    return imagen;
  };
  updatePrinterError(status) {
    if (this.laneConfig.identification.printers != null) {
      // console.log('Lane-' + this.laneId + ' printerErrorStatus laneContro-viewer ' + status);
      this.updatePrinterErrorEvent.emit({ laneId: this.laneId, status });
    }
  }

  autoDetectEventChange(event: MatSlideToggleChange) {
    this.laneConfig.general.autoDetecDirectionMode = this.autoDetecDirectionMode.value;
    this.updateLaneConfigEvent.emit({ laneConfig: this.laneConfig, laneId: this.laneId });
    const payload = {
      msg_type: 'configUpdate',
      lane: this.laneId,
      data: {
        path: `lanes[${this.laneId}].general.autoDetecDirectionMode`,
        param: 'autoDetecDirectionMode',
        value: this.laneConfig.general.autoDetecDirectionMode,
      },
    };
    this.wsService.send('configUpdate', payload);
    console.log(`L- ${this.laneId}: autoDetectEventChange ${event.checked}`);
  }

  laneEnableEventChange(event: MatSlideToggleChange) {
    this.laneConfig.general.laneEnabled = this.laneEnabled.value;
    this.updateLaneConfigEvent.emit({ laneConfig: this.laneConfig, laneId: this.laneId });
    const payload = {
      msg_type: 'configUpdate',
      lane: this.laneId,
      data: {
        path: `lanes[${this.laneId}].general.laneEnabled`,
        param: 'laneEnabled',
        value: this.laneConfig.general.laneEnabled,
      },
    };
    this.wsService.send('configUpdate', payload);
    console.log(`L- ${this.laneId}: laneEnableEventChange ${event.checked}`);
  }

  isModuleAvailable(moduleId: string) {
    return this.authenticationService.isModuleAvailable(moduleId, true);
  }

  restartPrinter(clusterKey: string) {
    const data: PrinterDialogData = {
      title: 'Reiniciar impresora',
      description: 'Seleccione la impresora que desea reiniciar',
      cluster: clusterKey,
      laneConfig: this.laneConfig,
      okButtonText: 'Reiniciar',
    };

    const dialogRef = this.dialog.open(PrinterDialogComponent, {
      width: '450px',
      data: data,
    });

    dialogRef.afterClosed().subscribe((printerId) => {
      if (printerId !== null) {
        const packet: any = {};
        packet.msg_type = Events.PRINTER_HARD_RESET;
        packet.printerId = printerId;

        this.wsService.send(Events.PRINTER_HARD_RESET, packet);
      }
    });
  }

  enablePrinter(clusterKey: string) {
    const data: PrinterDialogData = {
      title: 'Habilitar impresora',
      description: 'Seleccione la impresora que desea habilitar',
      cluster: clusterKey,
      laneConfig: this.laneConfig,
      okButtonText: 'Habilitar',
    };

    const dialogRef = this.dialog.open(PrinterDialogComponent, {
      width: '450px',
      data: data,
    });

    dialogRef.afterClosed().subscribe((printerId) => {
      if (printerId !== null) {
        const packet: any = {};
        packet.msg_type = Events.ENABLE_PRINTER;
        packet.printerId = printerId;

        this.wsService.send(Events.ENABLE_PRINTER, packet);
      }
    });
  }
}
